import { JobResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export const fetchAllJobKey = "all-job-key";

export async function fetchAllJob(data: {
  search: string;
  lokasi: string;
  divisi: string;
}): Promise<JobResponse[]> {
  const res = await ApiClient.get(
    `/AllJob?search=${data.search}&lokasi=${data.lokasi}&divisi=${data.divisi}`
  );
  return res.data;
}

export const useFetchAllJob = mutationWrapper(fetchAllJob);
